import React from "react";
import ListItem from "@mui/material/ListItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";

/**
 * @param {object} props
 * @param {"game" | "expansion" | undefined} props.gameType
 * @param {(value: "game" | "expansion") => void} props.onToggle
 */
export const GameTypeControl = ({ gameType, onToggle }) => {
  const onChangeHandler = (e) => {
    onToggle(e.target.value);
  };

  const value = gameType || "game";

  return (
    <ListItem>
      <FormControl sx={{ width: "100%" }} margin="normal">
        <InputLabel id="game-type-label">Game Type</InputLabel>
        <Select
          labelId="game-type-label"
          id="game-type"
          value={value}
          onChange={onChangeHandler}
          label="Game Type"
          input={<OutlinedInput label="Game Type" />}
        >
          <MenuItem value="game">Game</MenuItem>
          <MenuItem value="expansion">Expansion</MenuItem>
        </Select>
      </FormControl>
    </ListItem>
  );
};
